import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import WholenessRingSkeleton from './DashboardComponents/WholenessRingSkeleton';
import WholenessOverviewSkeleton from './DashboardComponents/WholenessOverviewSkeleton';
import TrendsChartSkeleton from './DashboardComponents/TrendsChartSkeleton';

const UserDashboardSkeleton = () => {
  return (
    <VStack width="100%" align="stretch" justify={'start'} spacing="35px" marginTop={'20px'}>
      {/* Title */}
      <VStack gap={'10px'}>
        <Text variant="loraSectionTitle" textAlign="start">
          Wholeness Ring & Overview
        </Text>
        <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
          This graph displays the total scores of your wholeness broken down per domain.
        </Text>
      </VStack>
      <HStack align="start" spacing="140px" w="full" flexWrap={{ base: 'wrap', lg: 'nowrap' }}>
        <WholenessRingSkeleton titleShown={false} />

        <VStack spacing="30px" align="stretch" flex="0.6" maxWidth="410px" height={'650px'}>
          <WholenessOverviewSkeleton />
        </VStack>
      </HStack>
      <TrendsChartSkeleton />
    </VStack>
  );
};

export default UserDashboardSkeleton;
